import { CardContent } from '@/components/Card'
import { Button } from '@/components/Button'

export interface WaitingOnClientProgressionProActionsProps {
  containsExtensionRejected: boolean
  onUploadRejectionConfirmation: () => unknown
}

export function WaitingOnClientProgressionProActions({
  containsExtensionRejected,
  onUploadRejectionConfirmation,
}: WaitingOnClientProgressionProActionsProps) {
  if (!containsExtensionRejected) {
    return null
  }

  return (
    <CardContent>
      <Button
        label="Upload Rejection Confirmation"
        variant="secondary"
        size="wide-slim"
        onPress={onUploadRejectionConfirmation}
        testId="job-progression-upload-rejection-confirmation-button"
      />
    </CardContent>
  )
}
